<template>
  <el-form-item
    :label="label"
    class="user-name"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="userName"
      :clearable="true"
      :maxlength="75"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'ユーザー名'
    },
    prop: {
      type: String,
      default: 'user_name'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '最大75文字'
    }
  },
  computed: {
    userName: {
      get () {
        return this.value
      },
      set (userName) {
        this.$emit('input', userName.toUpperCase())
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.user-name {
  ::v-deep .el-form-item__content {
    width: 18em;
  }
}
</style>
